import mutations from './adminSettings.mutations'
import actions from './adminSettings.actions'

const state = {
  showUploadModal: false,
  showLogoutModal: false
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
